export default "__VITE_ASSET__c259c511__"